import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/general/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ObjectStatus } from 'src/app/shared/model/object';
import { UntypedFormControl } from '@angular/forms';
import { ActiveRelatie, ObjectRelatieGegevens } from 'src/app/shared/model/relatie';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatGridTileHeaderCssMatStyler } from '@angular/material/grid-list';
import { GeneralFunctionsService } from 'src/app/shared/general-functions.service';

@Component({
  selector: 'app-status-edit',
  templateUrl: './status-edit.component.html',
  styleUrls: ['./status-edit.component.less']
})
export class StatusEditComponent implements OnInit {

@Input() status: ObjectStatus;
@Output() deleted = new EventEmitter();

relaties: Array<ActiveRelatie>;
statusList : any;
notChanged = true;
myControl = new UntypedFormControl();

filteredRelaties: Observable<ActiveRelatie[]>;

  constructor(private relatiesService : RelatiesService,
              private objectenService : ObjectenService,
              private dialog: MatDialog,
              private functions: GeneralFunctionsService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.relatiesService.getActiveRelatieList().subscribe(data => {
      this.relaties = data;
      this.filteredRelaties = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.BedrijfsNaam),
        map(name => name ? this._filter(name) : this.relaties.slice())
      );
      const currentrelatie = this.relaties.find(data => data.BedrijfNummer == this.status.BedrijfNummer);
      if (currentrelatie) this.myControl.setValue(currentrelatie);

    })
    this.objectenService.getStatusList().subscribe(data => {
      this.statusList = data;
    })



  }


  private _filter(name: string): ActiveRelatie[] {
    const filterValue = name.toLowerCase();
    return this.relaties.filter(option => (option.BedrijfsNaam + option.Afkorting).toLowerCase().indexOf(filterValue) >= 0);
  }

  save() {
    if (this.status.BedrijfNummer == null) {
      this.toastr.error("", "Bedrijf is niet geslecteerd!");
      return;
    }
    if (this.status.Omschrijving == null) {
      this.toastr.error("", "Omschrijving is niet ingevuld!");
      return;
    }
    if (this.status.DatumHeen == null) {
      this.toastr.error("", "Datum heen is niet ingevuld!");
      return;
    }
   this.status.KostenEuro = this.functions.strToNum(this.status.KostenEuro);
    if (this.status.ID == null) {
      this.objectenService.postObjectStatus(this.status).subscribe((data) => {
        this.status.ID = data.id;
        this.toastr.success("", "Toegevoegd");
      })
    } else {
      this.objectenService.putObjectStatus(this.status).subscribe(() => {
        this.toastr.success("", "Opgeslagen");
      })
    }
    this.notChanged = true;
  }



  delete() {
    const message = `Weet je zeker dat je dit wilt doen?`;

    const dialogData = new ConfirmDialogModel("Bevestig verwijdering", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      const result = dialogResult;
      if (result) {
          this.objectenService.deleteObjectStatus(this.status.ID).subscribe(() => {
            this.toastr.error("", "Verwijderd");
            this.deleted.emit(this.status.ID)
          }
          );
        }
      });

  }

  change(e:any) {
    this.notChanged=false;
  }

  displayBedrijf(relatie: ActiveRelatie ): string {
    if (relatie == null) return '';
    return relatie.BedrijfsNaam;
  }


  setKosten(value: any) {
    try {
      if (value.target && value.target.value) {
        let num : number = Number(value.target.value.replace(",","."));
        this.status.KostenEuro = num;
      }
      this.change(value);
    } catch (e) {
      console.log(e)
    }
  }

  textEntered(e){
    //this.searchText = e;
  }

  valueSelected(e){
    //this.selectedObject = JSON.stringify(e);
  }

}
